import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueResource from 'vue-resource';
import vue_moment from 'vue-moment';
import Auth from '@/authentication';
import Invoice from './components/Invoice/index.js';
Vue.use(Invoice, { store });
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(vue_moment);

Vue.use(VueResource);

Vue.use(Auth, {
    cognitoDomain: process.env.VUE_APP_COGNITO_DOMAIN,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectURL: process.env.VUE_APP_REDIRECT_URL,
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
